'use-client';
import FacebookLikeBox from '../../FacebookLikeBox';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';
import style from '../../style/FacebookLikeBox.scss';

export default WithConsentPolicy(FacebookLikeBox, {
  rootClassName: style.container,
  componentConsentPolicy: { advertising: true },
});
